import './RangeSlider.css';
import { forwardRef, useEffect, useMemo, useState } from "react";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

const CustomRangeSlider = forwardRef((props, ref) => {
  const [ refresh, setRefresh ] = useState(false);
  const [ value, setValue ] = useState(props.value || []);

  const defaultProps = {
   min: props.min || 0,
   max: props.max || 100
  };
  
  useEffect(() => {
    setValue(props.value)
    setRefresh(true)
  }, [props]);

  useEffect(() => {
    if (refresh) {
      setValue(props.value)
      setRefresh(false)
    }
  }, [refresh]);

  const sliderRangeLabel = useMemo(() => {
    const initialRange = value[0] || 0;
    const finalRange = value[1] || 0;

    const measure = props?.measure;

    return `${initialRange} ${measure} até ${finalRange} ${measure}`;
  }, [props, value]);

  const handleChange = (rangeValue) => {
   setValue(rangeValue);

   const element = { 
    target: { 
      name: props.name,
      value: rangeValue
    } 
   };

   props.onChange(element);
  }

  useEffect(() => {
    const initialRange = props.value.min;
    const finalRange = props.value.max;

    setValue([initialRange, finalRange]);
  }, []);

  return (
   <div className='range-slider-container'>
     <p>{sliderRangeLabel}</p>

     <RangeSlider 
       id={'id_' + props.name}
       value={value}
       onInput={handleChange}
       min={defaultProps.min}
       max={defaultProps.max}
       disabled={false}
       rangeSlideDisabled={false}
     />
   </ div>
  )
})

export default CustomRangeSlider;